import { Main } from '../../components'

const CommunityDashboard = () => {
  return (
    <Main>
      <div>CommunityDashboard!</div>
    </Main>
  )
}

export default CommunityDashboard
